/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * The component for Home routing
 *
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.2.0
 */

import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';
import { createStructuredSelector } from 'reselect';

import {
    makeSelectAuthAuthorities,
    makeSelectIsDashboardAvailable,
    makeSelectLoggedIn,
    makeSelectNewsServiceAccessLoggedIn,
    makeSelectSubscriberType,
} from '../../pages/PageAuth/selectors/authSelectors';
import { IAuthority } from '../../pages/PageAuth/types/authTypes';
import { IRootReducer } from '../../reducers/rootReducer';
import { RoutePath } from '../constants/routesConstants';
import { pageDashboardRedirectLogic } from './DashboardRoute';

export const HomeRoute = (props: RouteComponentProps & IConnectedProps) => {
    if (!props.loggedIn) {
        return <Redirect to={RoutePath.login} />;
    } else if (props.isNewsServiceUserLoggedIn) {
        return <Redirect to={RoutePath.news} />;
    } else if (props.isPageDashboardActive) {
        return <Redirect to={RoutePath.dashboard} />;
    } else {
        return pageDashboardRedirectLogic(props.authorities, props.subscriberType);
    }
};

interface IConnectedProps {
    authorities: IAuthority[];
    isPageDashboardActive: boolean;
    loggedIn: boolean;
    isNewsServiceUserLoggedIn: boolean;
    subscriberType: string | null;
}

const mapStateToProps = createStructuredSelector<IRootReducer, RouteComponentProps, IConnectedProps>({
    authorities: makeSelectAuthAuthorities(),
    isPageDashboardActive: makeSelectIsDashboardAvailable(),
    isNewsServiceUserLoggedIn: makeSelectNewsServiceAccessLoggedIn(),
    loggedIn: makeSelectLoggedIn(),
    subscriberType: makeSelectSubscriberType(),
});

export default connect(mapStateToProps)(HomeRoute);
